module.exports = __webpack_public_path__ + "assets/img/9_100.511b3dbb.jpg";